module.exports = __webpack_public_path__ + "site/img/en.c28e62cf.png";